// extracted by mini-css-extract-plugin
module.exports = {"container":"logo_container__LKtJC"};